export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 4
});

export const CURRENCY_CODES = [
  { label: 'USD', value: 'USD' },
  { label: 'CRC', value: 'CRC' }
];

export const convertCurrency = (amount, currencyCode = 'USD', exchangeRate = 1) => {
  const value = Number(amount) || 0;
  return currencyCode === 'CRC' ? value * (Number(exchangeRate) || 0) : value;
};

export const formatCurrency = (
  amount,
  currencyCode = 'USD',
  exchangeRate = 1,
  currencyDisplay = currencyCode === 'CRC' ? 'narrowSymbol' : 'symbol'
) => {
  const fractionDigits = currencyCode === 'CRC' ? 2 : 4;
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  });
  return formatter.format(convertCurrency(amount, currencyCode, exchangeRate));
};

export const formatUsd = (amount) => currencyFormatter.format(Number(amount) || 0);
